import { Button, Flex, Result } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
	const navigate = useNavigate();
	return (
		<Flex
			flex={1}
			align="center"
			justify="center"
			style={{ minHeight: '100vh', }}
		>
			<Result
				status="404"
				title="404"
				subTitle="Ops! Não encontramos essa página."
				extra={
					<Button onClick={() => navigate('/')} type="primary">
                        Voltar para o início
					</Button>
				}
			/>
		</Flex>
	);
}
